import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getAnalytics } from "firebase/analytics";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyBhtGxG8iuFgiBdhkeMrKTEMQHe7akFjBk",
  authDomain: "bsra-management.firebaseapp.com",
  projectId: "bsra-management",
  storageBucket: "bsra-management.appspot.com",
  messagingSenderId: "236676991055",
  appId: "1:236676991055:web:239944765e48a02b7e823a",
  measurementId: "G-HD37M7X9KG"
};

const app = initializeApp(firebaseConfig);

if (window.location.hostname === 'localhost') {
  window.FIREBASE_APPCHECK_DEBUG_TOKEN = '468E089B-99F0-4815-8D51-8353CB314C84';
}

initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider('6Lf3acUqAAAAAAlmyOs8heiUNn645eCEgltY5RaL'),
  isTokenAutoRefreshEnabled: true
});

export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "australia-southeast1");
export const analytics = getAnalytics(app);
export const storage = getStorage(app);
export { httpsCallable };
